var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "recovery-codes-generator-dialog",
        persistent: "",
        "max-width": "440"
      },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "v-icon",
            {
              staticClass: "rcg-close",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.closeDialog()
                }
              }
            },
            [_vm._v("close")]
          ),
          _vm._v(" "),
          _c("h1", { staticClass: "rcg-heading" }, [
            _vm._v(_vm._s(_vm.$t("Account.Recovery.Header")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "rcg-content" }, [
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.$t("Account.Recovery.Text")) }
            })
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "v-btn primary-btn",
              on: {
                click: function($event) {
                  return _vm.generateCodes()
                }
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("Account.Recovery.Button")))])]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7eddb32a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eddb32a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/IntegratedWallet/RecoveryCodesGeneratorDialog.vue
// module id = null
// module chunks = 